module.exports = __webpack_public_path__ + "img/Frame 1886.9710fd55.png";